import { Grid, useTheme } from "@mui/material"
import Logo from "../../assets/img/logo animation.svg"
import { AnimatedLogo } from "./logo"
import { useEffect, useLayoutEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { Constants } from "../../utils"

export const AnimationLayout = ({ withAnimation = true }: { withAnimation?: boolean }) => {
    const { palette } = useTheme()
    const navigate = useNavigate()
    const duration = 0.5
    const [init, setIinit] = useState(false)

    const [initColorChange, setInitColorChange] = useState(false)
    const [animationHasEnded, setAnimationHasEnded] = useState(false)

    const [translateYValue, setTranslateYValue] = useState("0")
    const [widthValue, setWidthValue] = useState("237px")
    const [heightValue, setHeightValue] = useState("110px")

    const [showOutlet, setShowOutlet] = useState(false)

    useEffect(() => {
        if (withAnimation) {
            setTimeout(() => {
                setIinit(true)
            }, 500);
        } 
    }, [withAnimation])

    useLayoutEffect(() => {
        if (!withAnimation) {
            setAnimationHasEnded(true)
            setShowOutlet(true)
            setInitColorChange(true)
        } 
    }, [withAnimation])

    useEffect(() => {
        if (animationHasEnded) {

            setTranslateYValue("calc(-50vh + 50px)")
            setWidthValue("71px")
            setHeightValue("33px")

            setTimeout(() => {
                setShowOutlet(true)
            }, duration * 1000);
        }
    }, [animationHasEnded])

    return (
        <Grid
            id={"container-layout"}
            sx={{
                width: "100vw",
                height: "100vh",
                backgroundColor: initColorChange ? palette.common.white : palette.secondary.main,
                display: "flex",
                alignItems: "center",
                justifyContent: showOutlet ? "flex-start" : "center",
                transition: `background-color ${duration}s ease`,
                flexDirection: "column",
                position: "relative",
                overflowX: "hidden"
            }}
        >

            {(!animationHasEnded) && <AnimatedLogo
                init={init}
                duration={duration}
                onAnimationEnd={() => {
                    setTimeout(() => {
                        setAnimationHasEnded(true)
                    }, duration * 1000);
                }}
                onInitChangeColor={() => setInitColorChange(true)}
            />}

            {(animationHasEnded) &&
                <img
                    src={Logo}
                    alt="Logo"
                    style={{
                        ... (!showOutlet && {
                            transform: `translateY(${translateYValue})`,
                            transition: `all ${duration}s ease-out`,
                        }),
                        width: widthValue,
                        height: heightValue,
                        ... (showOutlet && {
                            position: 'absolute',
                            top: "20px"
                        })
                    }}
                    onClick={() => navigate("/" + window.location.search)}
                />
            }

            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: showOutlet ? 1 : 0, scale: showOutlet ? 1 : 0.9 }}
                transition={{ duration: 0.5 }} // Tempo da transição do fade
            >
                {showOutlet &&
                    <Grid
                        mt={"80px"}
                        padding={"0px 0rem"}
                        display={"flex"}
                        flexDirection={"column"}
                        alignItems={"center"}
                        width={"100vw"}
                        maxWidth={`${Constants.screenMaxWidth}px`}
                        minHeight={"calc(100vh - 80px)"}
                    >
                        <Outlet />
                    </Grid>
                }
            </motion.div>
        </Grid>
    )
}